import { fetchUserTasks } from '@/api/user-task.api';
import type { IFindUserTasksQuery, IUserTask } from '@condo/domain';
import { useQuery } from '@tanstack/vue-query';
import { computed, unref, type MaybeRef } from 'vue';

export const useUserTasks = (params: MaybeRef<IFindUserTasksQuery>) => {
    const queryFilter = computed(() => unref(params));
    const queryEnabled = computed(() => Object.keys(queryFilter.value).length > 0);

    return useQuery(['user-tasks', queryFilter], async (): Promise<{ userTasks: IUserTask[]; total: number }> => fetchUserTasks(queryFilter.value), {
        initialData: { userTasks: [], total: 0 },
        enabled: queryEnabled,
    });
};
